// extracted by mini-css-extract-plugin
export default {"wrapper":"title-button-module--wrapper--vIH36","title":"title-button-module--title--2zTi9","smallTitle":"title-button-module--smallTitle--16Dkj"};